/** @format */

const API_MOCK_SWITCH = true;
//无库存
const NoStock = '34';
const API_SUCCESS = '0';
export { API_MOCK_SWITCH, NoStock, API_SUCCESS };
